/**
 * @author Aydin Cinar
 */

(function(app) {
    app.swiper = (function() {
        var initialized = false;

        var selectors = {
            swiperContainer     : '.swiper-container',
            swiperNext          : '.swiper-button-next',
            swiperPrev          : '.swiper-button-prev'
        };

        var init = function() {
            initialized = true;

            app.$objs.menuToggle   = $(selectors.menuToggle);
            bind();
        };

        var bind = function() {
            $(window).load(function () {
                swiperInit();
            });

        };

        var swiperInit = function() {
            var mySwiper = new Swiper (selectors.swiperContainer , {
                direction: 'horizontal',
                loop: false,
                autoHeight: true,
                // Navigation arrows
                nextButton: selectors.swiperNext,
                prevButton: selectors.swiperPrev

            });
        };


        var isInitialized = function() {
            return initialized;
        };

        return {
            init:          init,
            isInitialized: isInitialized
        };
    })();

    app.registerInit('swiper');
})(engelsizyasam);